import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { hospitalActions } from '../../../_actions/hospital.actions'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { FaRegFilePdf } from "react-icons/fa";
import MultipleSelectChip from './MultipleSelectChip';



const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  bgcolor: 'background.paper',
  borderRadius: '8px',       // Add this line for rounded corners
  boxShadow: 24,
  p: 4,
  height: '80%',
  overflowY: 'scroll'
};

export default function EditProfileModel(props) {
  let { closeDrModel, open } = props
  let closeModel = () => {
    
    setErrors({})
    closeDrModel()
    dispatch(hospitalActions.uploadImageClear())
    dispatch(hospitalActions.clearimage())
  }
  React.useEffect(() => {
    let type = {
      type:"HOSPITAL"
    }
    let fetchallcity = async () => {
      dispatch(hospitalActions.getAllCity())
      dispatch(hospitalActions.SpecializationIdHospital(type));
      dispatch(hospitalActions.getHospitalProfile())
    }
    fetchallcity()
  }, [open])
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  let { dashboard, users, hospital } = selector
  let { userData } = selector && dashboard
  let { getAllCity } = users && users
  const [fieldsUser, setFieldsUser] = React.useState({});
  const [selectedOptions, setSelectedOptions] = React.useState([]);
  const handleMultiselectChange = (selectedList, selectedItem) => {
    console.log(selectedList,selectedItem)
    setSelectedOptions(selectedList);
    const filteredList = selectedList.filter(item => item !== null);
    const hospitalTreatmentList = filteredList.map((e) => e.value);
    setFieldsUser({...fieldsUser, hospitalTreatmentList: hospitalTreatmentList.filter(Boolean)});
  };

  React.useEffect(() => {
    setFieldsUser({
      hospitalName: userData?.hospitalName,
      state: userData?.state,
      city: userData?.city?.id,
      // location:userData?.location,
      timings: userData?.timings,
      landmark: userData?.landmark,
      pincode: userData?.pincode,
      gmap: userData?.gmap,
      contactNumber: userData?.contactNumber,
      line_1: userData?.line_1,
      line_2: userData?.line_2,
      district:userData?.district,
      alternateNumber: userData?.alternateNumber,
      documents: userData?.documents,
      profilePhoto: userData?.profilePhoto,
      specializationId: userData?.specializationId?.id,
      hospitalDescription: userData?.hospitalDescription,
      address:userData?.address,
      hospitalTreatmentList:userData?.hospitalTreatmentList.map((e)=>e.id)
  

    })


 
      setSelectedOptions(userData?.hospitalTreatmentList.map((e)=>{ 
        return {
          key : e.name,
          value : e.id
        }
       }))
 
  

  }, [userData])


console.log(fieldsUser)
  
  
  const [error, setErrors] = React.useState({});
  const [data, setData] = React.useState(null);

  const handleValidationUserInfo = () => {
    let formIsValid = true;
    let newErrors = {};
    setErrors(newErrors);
    console.log("newErrors", newErrors)
    return formIsValid;
  };

  const submitDetails = () => {

    if (handleValidationUserInfo()) {  

      dispatch(hospitalActions.updateHospitalInfo(
        {
          hospitalName: userData?.hospitalName, ...fieldsUser, profilePhoto: users?.filesDetails?.imageName || fieldsUser?.profilePhoto,
          documents: hospital?.Doc_filesDetails?.imageName || fieldsUser?.documents
        }
        ))
        dispatch(hospitalActions.uploadImageClear())
        closeModel()
      }
  

  }
  let handleSubmitImage = async (e) => {
    e.preventDefault()
    if (e.target.files[0].type.startsWith('image/')) {
      dispatch(hospitalActions.uploadImage({ image: e.target.files[0] }))
    }
  }
  let handleSubmitImageDocument = async (e) => {
    e.preventDefault()
    dispatch(hospitalActions.uploadImageDocument({ image: e.target.files[0] }))
  }

  
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == "pincode" && value.length == 6) {
      dispatch(hospitalActions.getOneRecordByPincode({ pincode: value }))
    }
    setFieldsUser((prevUserData) => ({ ...prevUserData, [name]: value }));
    setErrors({ ...error, [name]: "" })

  };
 
  let [options,setoptions] = React.useState([])


  React.useEffect(() => {
    if (hospital?.pincode) {

      setFieldsUser({ ...fieldsUser, state: hospital?.pincode?.stateName, })
    }

  }, [hospital?.pincode])

  let [treatementListtoSave, settreatementListtoSave] = React.useState([])

 

  return (

    <div>
      <Modal
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="flex justify-center h-full items-center">


          <Box className=" w-[50%] h-[60vh] bg-gray-100 rounded-lg shadow-lg p-4  " >

            <Box className='bg-[#005F60] rounded-xl  flex justify-between items-center '>
              <Box className="px-3 py-2 text-white font-bold" >Update Hospital</Box>
              <Box className="px-3 py-2 text-white font-bold"><CloseRoundedIcon onClick={closeModel} className=" cursor-pointer text-white font-bold" /></Box>
            </Box>

            <form className=" w-full mx-auto  h-[90%] p-4  overflow-y-scroll space-y-6">


              <div className='flex flex-col gap-3'>


                <div className=''>

                  {/* hospitalName */}
                  <div className='lg:flex gap-2 items-center justify-center'>

                  <div className=' flex-1'>
                    <label htmlFor="hospitalName" className="block text-sm font-medium text-gray-700">
                      Hospital Name
                    </label>
                    <input
                      id="hospitalName"
                      name="hospitalName"
                      type="text"
                      placeholder="Enter Hospital name"
                      className={`mt-1 p-2 w-full rounded-md border  focus:outline-none focus:border-blue-500`}
                      value={fieldsUser.hospitalName}
                      onChange={handleChange}
                    />
                    {error['hospitalName'] && <p className='text-sm text-red-500'>{error.hospitalName}</p>}
                  </div>
                  <div className='flex-1'>
                      <label htmlFor="specializationId" className="block text-sm font-medium text-gray-700">
                        Specialization
                      </label>
                      <select
                        id="specializationId"
                        name="specializationId"
                        className={`mt-1 p-2 w-full bg-white rounded-md border ${error.specializationId ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser.specializationId}
                        onChange={handleChange}
                      >
                        <option value="">Select Specialization</option>
                        {selector?.hospital?.specializationid?.SpecializationId.map((e) => (

                          <option key={e.id} value={e.id}>{e?.name}</option>
                        ))}
                      </select>
                      {error['specializationId'] && <p className='text-sm text-red-500'>{error.specializationId}</p>}
                    </div>
                    </div>



<div className=' mt-1 mb-1'>
<label htmlFor="timings" className="block text-sm font-medium text-gray-700">
                        Treatements
                      </label>
  <MultipleSelectChip handleMultiselectChange={handleMultiselectChange} settreatementListtoSave={settreatementListtoSave} options={options} setoptions={setoptions} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions}/>
</div>


<div className='lg:flex gap-2 items-center justify-center'>
<div className='flex-1'>
                      <label htmlFor="timings" className="block text-sm font-medium text-gray-700">
                        Timing
                      </label>
                      <textarea
                      rows={2}
                        id="timings"
                        name="timings"
                        type="text"
                        placeholder="Enter Hospital Timing"
                        className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser.timings}
                        onChange={handleChange}
                      />
                      {error['timings'] && <p className='text-sm text-red-500'>{error.timings}</p>}
                    </div>
                    <div className='flex-1'>
                      <label htmlFor="gmap" className="block text-sm font-medium text-gray-700">
                        Google Map URL
                      </label>
                      <textarea
                      rows={2}
                        id="gmap"
                        name="gmap"
                        type="text"
                        placeholder="Enter Google Map URL"
                        className={`mt-1 p-2 w-full rounded-md border ${error.gmap ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser.gmap}
                        onChange={handleChange}
                      />
                      {error['gmap'] && <p className='text-sm text-red-500'>{error.gmap}</p>}
                    </div>
</div>

<div className='lg:flex gap-2 items-center justify-center '>
<div className='flex-1'>
                      <label htmlFor="contactNumber" className="block text-sm font-medium text-gray-700">
                        Contact Number
                      </label>
                      <input
                        id="contactNumber"
                        name="contactNumber"
                        type="number"
                        placeholder="Contact Number"
                        className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser && fieldsUser.contactNumber ? fieldsUser.contactNumber : ""}
                        onChange={handleChange}
                      />
                      {error['contactNumber'] && <p className='text-sm text-red-500'>{error.contactNumber}</p>}
                    </div>

                    <div className='flex-1'>
                      <label htmlFor="alternateNumber" className="block text-sm font-medium text-gray-700">
                        Alternate Contact Number (Optional)
                      </label>
                      <input
                        id="alternateNumber"
                        name="alternateNumber"
                        type="number"
                        placeholder="Alternate Contact Number (Optional)"
                        className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser && fieldsUser.alternateNumber ? fieldsUser.alternateNumber : ""}
                        onChange={handleChange}
                      />
                      {error['alternateNumber'] && <p className='text-sm text-red-500'>{error.alternateNumber}</p>}
                    </div>
</div>

<div  className='lg:flex gap-2 items-center justify-center '>
<div className='flex-1'>
                      <label htmlFor="address" className="block text-sm font-medium text-gray-700">
                        Address 
                      </label>
                      <input
                        id="address"
                        name="address"
                        type="text"
                        placeholder="Address"
                        className={`mt-1 p-2 w-full rounded-md border ${error.address ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser.address}
                        onChange={handleChange}
                      />
                      {error['address'] && <p className='text-sm text-red-500'>{error.address}</p>}
                    </div>
                    <div className='flex-1'>
                      <label htmlFor="line_1" className="block text-sm font-medium text-gray-700">
                        Landmark
                      </label>
                      <input
                        id="line_1"
                        name="line_1"
                        type="text"
                        placeholder="Landmark"
                        className={`mt-1 p-2 w-full rounded-md border ${error.line_1 ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser.line_1}
                        onChange={handleChange}
                      />
                      {error['line_1'] && <p className='text-sm text-red-500'>{error.line_1}</p>}
                    </div>
                    <div className='flex-1'>
                      <label htmlFor="line_2" className="block text-sm font-medium text-gray-700">
                        Area
                      </label>
                      <input
                        id="line_2"
                        name="line_2"
                        type="text"
                        placeholder="Area"
                        className={`mt-1 p-2 w-full rounded-md border ${error.line_2 ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser.line_2}
                        onChange={handleChange}
                      />
                      {error['line_2'] && <p className='text-sm text-red-500'>{error.line_2}</p>}
                    </div>

</div>

<div  className='lg:flex gap-2 items-center justify-center '>

<div className='flex-1'>
                      <label htmlFor="pincode" className="block text-sm font-medium text-gray-700">
                        Pincode
                      </label>
                      <input
                        id="pincode"
                        name="pincode"
                        type="number"
                        placeholder="Enter Pincode"
                        className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser.pincode}
                        onChange={handleChange}
                      />
                      {error['pincode'] && <p className='text-sm text-red-500'>{error.pincode}</p>}
                    </div>


                    <div className='flex-1'>
                      <label htmlFor="district" className="block text-sm font-medium text-gray-700">
                        District
                      </label>
                      <input
                        id="district"
                        name="district"
                        type="text"
                        placeholder="Enter District"
                        className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser.district}
                        onChange={handleChange}
                      />
                      {error['district'] && <p className='text-sm text-red-500'>{error.district}</p>}
                    </div>


                    <div className='flex-1'>
                      <label htmlFor="city" className="block text-sm font-medium text-gray-700">
                        City
                      </label>
                      <select
                        id="city"
                        name="city"
                        className={`mt-1 bg-white p-2 w-full rounded-md border ${error.title ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser?.city}
                        onChange={handleChange}
                      >
                        <option value="">Select City</option>
                        {getAllCity?.map((e) => (
                          <option key={e.id} value={e.id}>{e?.name}</option>
                        ))}
                      </select>
                      {error['city'] && <p className='text-sm text-red-500'>{error.city}</p>}
                    </div>

</div>














<div  className='lg:flex gap-2 items-center justify-center '>
<div className='flex-1'>
                      <label htmlFor="state" className="block text-sm font-medium text-gray-700">
                        State
                      </label>
                      <input
                        id="state"
                        name="state"
                        type="text"
                        placeholder="State"
                        className={`mt-1 p-2 w-full rounded-md border ${error.state ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        value={fieldsUser?.state}
                      // onChange={handleChange}
                      />
                      {error['state'] && <p className='text-sm text-red-500'>{error.state}</p>}
                    </div>

<div className='flex-1'>
                      
                    </div>


                    <div className='flex-1'>
                   
                    </div>
                  

</div>


                  {/* Address number */}
                  <div div className=''>
                    <label htmlFor="hospitalDescription" className="block text-sm font-medium text-gray-700">
                      Description
                    </label>

                    <textarea
                      multiline
                      id="hospitalDescription"
                      name="hospitalDescription"
                      type="text"
                      rows={Math.max(5, (userData?.hospitalDescription || "All is good").split('\n').length)}
                      variant='outlined'
                      value={fieldsUser?.hospitalDescription}
                      className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                        } focus:outline-none focus:border-blue-500`}
                      style={{ resize: 'vertical', minHeight: '2em' }}
                      onChange={handleChange}
                    />

                    {error['hospitalDescription'] && <p className='text-sm text-red-500'>{error.hospitalDescription}</p>}
                  </div>
                  <div className='lg:flex w-[98%]  gap-2'>
                    
                


                  </div>
 
                  

<div className='lg:flex gap-2'>


                  <div className='my-2 flex-1 gap-2 justify-between'>
                  {!users.filesDetails?.imageUrl&&!userData?.imageLinkUrl?<img className=' w-32 h-32 rounded-full' src={"https://i.postimg.cc/zf4HQ1gZ/profile.png"}/>:
                <img onError={(e) => {
                  e.target.onerror = null; 
                  e.target.src = "https://i.postimg.cc/zf4HQ1gZ/profile.png"; 
                }}   className=' w-32 h-32 rounded-full' src={users.filesDetails?.imageUrl || userData?.imageLinkUrl}/>  }
                  
                    <div className='mt-2'>
                      <label htmlFor="profileImage" className="block text-sm font-medium text-gray-700">
                        Profile Image (JPG/SVG/PNG/WEBP)
                      </label>
                      <input
                        id="profileImage"
                        name="profileImage"
                        type="file"
                        placeholder="Google Map Link"
                        className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        onChange={handleSubmitImage}
                        />
                        image Size 200X200
                      {error['profileImage'] && <p className='text-sm text-red-500'>{error.name}</p>}
                    </div>
                  </div>
                  <div className='my-2 flex-1 gap-2 justify-between'>
                  {
                      hospital && hospital?.Doc_filesDetails && hospital?.Doc_filesDetails?.imageUrl ? (
                        hospital && hospital?.Doc_filesDetails && hospital?.Doc_filesDetails?.imageUrl && hospital?.Doc_filesDetails?.imageUrl.toLowerCase().endsWith('.pdf') ? (
                      
                          <div ><FaRegFilePdf className='w-32 h-32 text-red-700' onClick={() => window.open(hospital && hospital?.Doc_filesDetails && hospital?.Doc_filesDetails?.imageUrl, '_blank')} /></div>
                        ) : (
                          
                          <img  onError={(e) => {
                            e.target.onerror = null; 
                            e.target.src = "https://i.postimg.cc/bwthTcp2/download.png"; 
                          }} className='w-32 h-32 rounded-sm' src={hospital && hospital?.Doc_filesDetails && hospital?.Doc_filesDetails?.imageUrl || userData?.imageDocumentsUrl||"https://i.postimg.cc/bwthTcp2/download.png"}/>
                        )
                      ) : (
                        userData && userData?.imageDocumentsUrl && userData?.imageDocumentsUrl.toLowerCase().endsWith('.pdf') ? (
                          <div ><FaRegFilePdf className='w-32 h-32 text-red-700' onClick={() => window.open(userData && userData?.imageDocumentsUrl, '_blank')} /></div>
                        ) : (
                          <img onError={(e) => {
                            e.target.onerror = null; 
                            e.target.src = "https://i.postimg.cc/bwthTcp2/download.png"; 
                          }}  className='w-32 h-32 rounded-sm' src={hospital && hospital?.Doc_filesDetails && hospital?.Doc_filesDetails?.imageUrl || userData && userData?.imageDocumentsUrl||"https://i.postimg.cc/bwthTcp2/download.png"}  />
                        )
                      )
                    }
                    <div className='mt-2'>
                      <label htmlFor="imageDocumentsUrl" className="block text-sm font-medium text-gray-700">
                        Document
                      </label>
                      <input
                        id="imageDocumentsUrl"
                        name="imageDocumentsUrl"
                        type="file"
                        placeholder="Google Map Link"
                        className={`mt-1 p-2 w-full rounded-md border ${error.name ? 'border-red-500' : 'border-gray-300'
                          } focus:outline-none focus:border-blue-500`}
                        onChange={handleSubmitImageDocument}
                      />
                      image Size 200X200
                      {error['imageDocumentsUrl'] && <p className='text-sm text-red-500'>{error.name}</p>}
                    </div>
                    {/* <img className=' w-32 h-32  rounded-sm' src={hospital?.Doc_filesDetails?.imageUrl || userData?.imageDocumentsUrl
                    } /> */}
                   

                  </div>
                  </div>
                </div>
              </div>
              <div className='flex justify-center items-center'>

              <button
                onClick={submitDetails}
                type="button"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-[#005F60] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                Update Hospital
              </button>
                </div>
            </form>

          </Box>

        </Box>
      </Modal>
    </div>

  );
}